(function () {
  const mobileQuery = window.matchMedia('(max-width: 768px)');
  const appName = 'Boosted Club';
  const assetUrl = 'https://cdn.jsdelivr.net/npm/pwa-add-to-homescreen@4.1.0/dist/assets/img/';
  const fallbackIconUrl = 'https://cdn.shopify.com/s/files/1/0729/3111/5206/files/BoosHFGHFGHFted_4.png?v=1773961523';

  let instance = null;

  function isStandalone() {
    return window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;
  }

  function getAppIconUrl() {
    const appleIcon = document.querySelector('link[rel="apple-touch-icon"]');
    return appleIcon && appleIcon.href ? appleIcon.href : fallbackIconUrl;
  }

  function ensureInstance() {
    if (instance) return instance;
    if (typeof window.AddToHomeScreen !== 'function') return null;

    instance = window.AddToHomeScreen({
      appName,
      appNameDisplay: 'standalone',
      appIconUrl: getAppIconUrl(),
      assetUrl,
      maxModalDisplayCount: -1,
      displayOptions: { showMobile: true, showDesktop: false },
      allowClose: true,
      showArrow: true
    });

    window.BoostedAddToHomeScreen = instance;
    return instance;
  }

  function updateCards() {
    const shouldShow = mobileQuery.matches && !isStandalone();

    document.querySelectorAll('[data-bc-a2hs-card]').forEach((card) => {
      card.hidden = !shouldShow;
    });
  }

  function bindTriggers() {
    document.querySelectorAll('[data-bc-a2hs-trigger]').forEach((button) => {
      if (button.dataset.bcA2hsBound === 'true') return;

      button.dataset.bcA2hsBound = 'true';
      button.addEventListener('click', () => {
        const adhs = ensureInstance();
        if (!adhs) return;
        adhs.show('en');
      });
    });
  }

  function init() {
    ensureInstance();
    bindTriggers();
    updateCards();
  }

  document.addEventListener('DOMContentLoaded', init);
  window.addEventListener('load', init);

  if (typeof mobileQuery.addEventListener === 'function') {
    mobileQuery.addEventListener('change', updateCards);
  } else if (typeof mobileQuery.addListener === 'function') {
    mobileQuery.addListener(updateCards);
  }
})();
